export default __webpack_public_path__ + "static/media/vintagedomusFiverrFeedback.ef21002a.png";